(() => {
  const init = (root) => {
    if (root.dataset.carouselReady === 'true') return;
    const track = root.querySelector('[data-carousel-track]');
    const navigation = root.querySelector('[data-carousel-navigation]');
    const previous = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    const status = root.querySelector('[data-carousel-status]');
    if (!track || !navigation || !previous || !next || !status) return;
    root.dataset.carouselReady = 'true';
    const cards = [...track.children];
    const mobile = window.matchMedia('(max-width: 760px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const description = track.getAttribute('aria-describedby');
    const pattern = status.dataset.statusTemplate;
    navigation.hidden = false;
    const step = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
    const update = () => {
      track.tabIndex = mobile.matches ? 0 : -1;
      if (mobile.matches) track.setAttribute('aria-describedby', description);
      else track.removeAttribute('aria-describedby');
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
      const first = Math.min(cards.length - 1, Math.max(0, Math.round(track.scrollLeft / Math.max(1, step()))));
      const last = Math.min(cards.length, first + (mobile.matches ? 2 : cards.length));
      const text = pattern.replace('%first%', String(first + 1)).replace('%last%', String(last)).replace('%total%', String(cards.length));
      if (status.textContent !== text) status.textContent = text;
    };
    const move = (direction) => track.scrollBy({ left: direction * step(), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('keydown', (event) => {
      if (!mobile.matches || event.target !== track) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }
    });
    let scheduled = false;
    track.addEventListener('scroll', () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; update(); });
    }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    else window.addEventListener('resize', update);
    mobile.addEventListener('change', update);
    update();
  };
  const scan = (scope) => scope.querySelectorAll('[data-waxy-carousel]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
